import { type ComponentPropsWithoutRef } from 'react';
import {
  Plus,
  Search,
  Pin,
  PinOff,
  Archive,
  Trash2,
  Pencil,
  GitFork,
  Eye,
  EyeOff,
  MoreVertical,
  MoreHorizontal,
  ChevronDown,
  ChevronRight,
  ChevronLeft,
  Loader,
  Loader2,
  Clock,
  AlertCircle,
  CircleAlert,
  Check,
  CircleCheck,
  Square,
  ArrowUp,
  ArrowDown,
  Sparkles,
  Wrench,
  Bot,
  Brain,
  Copy,
  FileText,
  FilePen,
  Files,
  Terminal,
  FolderSearch,
  Globe,
  ListChecks,
  ShieldQuestion,
  Map,
  Settings,
  Wifi,
  WifiOff,
  LogOut,
  Sun,
  Moon,
  Menu,
  X,
  GitBranch,
  Folder,
  FolderOpen,
  BookOpen,
  RefreshCw,
  FileEdit,
  FilePlus,
  Notebook,
  Bell,
  Cog,
  ShieldCheck,
  ScrollText,
  Zap,
  HelpCircle,
  Play,
  ShieldAlert,
  RotateCcw,
  RotateCw,
  CornerUpRight,
  AlertTriangle,
  XCircle,
  PauseCircle,
  Server,
  Infinity as InfinityIcon,
  BarChart3,
  Image as ImageIcon,
  Paperclip,
  Activity,
  Download,
  Building2,
  type LucideIcon,
} from 'lucide-react';

const iconMap = {
  Plus,
  Search,
  Pin,
  PinOff,
  Archive,
  Trash2,
  Pencil,
  GitFork,
  Eye,
  EyeOff,
  MoreVertical,
  MoreHorizontal,
  ChevronDown,
  ChevronRight,
  ChevronLeft,
  Loader,
  Loader2,
  Clock,
  AlertCircle,
  CircleAlert,
  Check,
  CircleCheck,
  Square,
  ArrowUp,
  ArrowDown,
  Sparkles,
  Wrench,
  Bot,
  Brain,
  Copy,
  FileText,
  FilePen,
  Files,
  Terminal,
  FolderSearch,
  Globe,
  ListChecks,
  ShieldQuestion,
  Map,
  Settings,
  Wifi,
  WifiOff,
  LogOut,
  Sun,
  Moon,
  Menu,
  X,
  GitBranch,
  Folder,
  FolderOpen,
  BookOpen,
  RefreshCw,
  FileEdit,
  FilePlus,
  Notebook,
  Bell,
  Cog,
  ShieldCheck,
  ScrollText,
  Zap,
  HelpCircle,
  Play,
  ShieldAlert,
  RotateCcw,
  RotateCw,
  CornerUpRight,
  AlertTriangle,
  XCircle,
  PauseCircle,
  Server,
  Infinity: InfinityIcon,
  BarChart3,
  Image: ImageIcon,
  Paperclip,
  Activity,
  Download,
  Building2,
} as const satisfies Record<string, LucideIcon>;

export type IconName = keyof typeof iconMap;

export interface IconProps extends Omit<ComponentPropsWithoutRef<'svg'>, 'name'> {
  name: IconName;
  /** Pixel size (width & height). @default 16 */
  size?: number;
  className?: string;
}

export function Icon({ name, size = 16, className, ...rest }: IconProps) {
  const LucideComponent = iconMap[name];
  return <LucideComponent size={size} className={className} {...rest} />;
}
